export interface TournamentResult {
  tournamentId: string;
  tournamentName: string;
  position: number;
  pointsAwarded: number;
}

export interface LeagueStanding {
  participantName: string;
  participantUserId?: string;
  totalPoints: number;
  tournamentResults: TournamentResult[];
  tournamentsPlayed: number;
  position: number;
}
